import * as Yup from "yup";
 
const RoleValidation = Yup.object().shape({
    roleId: Yup.string().required("User role is required"),
});
export default RoleValidation;
